import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  addReview,
  addReviewFailed,
  addReviewSuccess,
  getReviews,
  getReviewsFailed,
  getReviewsSuccess,
  searchUser,
  searchUserFailed,
  searchUserSuccess,
  updateReview,
  updateReviewFailed,
  updateReviewSuccess,
  getReviewDetails,
  getReviewDetailsFailed,
  getReviewDetailsSuccess,
} from './slice';
import * as endpoints from './endpoints';
import { request } from '@app/services';

function* addReviewSaga(action: ReturnType<typeof addReview>): any {
  try {
    const {
      behavior,
      projectInvolvement,
      communicationSkills,
      learningSkills,
      decisionMakingSkills,
      leadershipSkills,
      fairTreatment,
      taskPerformance,
      reviewTo,
      description,
      overall,
      isManagerSelected,
      disciplineManners,
    } = action.payload;
    const data = isManagerSelected
      ? {
          learningSkills,
          taskPerformance,
          projectInvolvement,
          communicationSkills,
          behavior,
          overall,
          description,
          disciplineManners,
          reviewTo: Number(reviewTo),
        }
      : {
          behavior,
          decisionMakingSkills,
          leadershipSkills,
          communicationSkills,
          fairTreatment,
          overall,
          description,
          disciplineManners,
          reviewTo: Number(reviewTo),
        };
    const result = yield call(request.post, endpoints.addReview, data);
    yield put(addReviewSuccess(result.data));
  } catch (err) {
    yield put(addReviewFailed(err));
  }
}
//
function* getReviewsSagas(action: ReturnType<typeof getReviews>): any {
  try {
    const result = yield call(request.get, endpoints.reviews);
    yield put(getReviewsSuccess(result.data));
  } catch (err) {
    yield put(getReviewsFailed(err));
  }
}
//
function* searchUsersSaga(action: ReturnType<typeof searchUser>): any {
  try {
    const query = action.payload;

    const params: Record<string, string> = {};
    if (typeof query === 'string') {
      params.q = query;
    }

    const result = yield call(request.get, endpoints.searchUser, { params });
    yield put(searchUserSuccess(result.data));
  } catch (err) {
    yield put(searchUserFailed(err));
  }
}
//
function* updateReviewSaga(action: ReturnType<typeof updateReview>): any {
  try {
    const {
      id,
      behavior,
      projectInvolvement,
      communicationSkills,
      learningSkills,
      decisionMakingSkills,
      leadershipSkills,
      fairTreatment,
      taskPerformance,
      reviewTo,
      description,
      overall,
      isManagerSelected,
      disciplineManners,
    } = action.payload;
    const data = isManagerSelected
      ? {
          learningSkills,
          taskPerformance,
          projectInvolvement,
          communicationSkills,
          behavior,
          overall,
          description,
          reviewTo,
          disciplineManners,
        }
      : {
          behavior,
          decisionMakingSkills,
          leadershipSkills,
          communicationSkills,
          fairTreatment,
          overall,
          description,
          reviewTo,
          disciplineManners,
        };
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateReview}${id}`, data);
    yield put(updateReviewSuccess(result.data));
    yield put(getReviewDetails(id));
  } catch (err) {
    yield put(updateReviewFailed(err));
  }
}
//
function* getReviewDetailsSaga(action: ReturnType<typeof getReviewDetails>): any {
  try {
    const reviewId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getReviewDetails}${reviewId}`);
    yield put(getReviewDetailsSuccess(result.data));
  } catch (err) {
    yield put(getReviewDetailsFailed(err));
  }
}
//
function* reviewsSagas() {
  yield all([
    takeLatest([getReviews, addReviewSuccess, updateReviewSuccess], getReviewsSagas),
    takeLatest(addReview, addReviewSaga),
    takeLatest(searchUser, searchUsersSaga),
    takeLatest(updateReview, updateReviewSaga),
    takeLatest(getReviewDetails, getReviewDetailsSaga),
  ]);
}
export { reviewsSagas };
